module.exports = __webpack_public_path__ + "static/media/sk.e89b8883.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/sk.svg
// module id = 1471
// module chunks = 0